import React from 'react'
import phoneIcon from '../../images/svg/nav/phone.svg'
import './TelephoneNumber.scss'

const TelephoneNumber = ({ showIcon = true, showUnderline = true, className = '' }) => (
  <a className={`contact-link ${className}`.trim()} href='tel:+421918040888' itemProp='telephone'>
    {showIcon && <img src={phoneIcon} alt='' className='contact-link-icon' />}
    {showUnderline
      ? <span className='contact-link-text'>+421 918 040 888</span>
      : '+421 918 040 888'
    }
  </a>
)

export default TelephoneNumber
